import { useAuth } from '../context/AuthContext';
import AppNav from './AppNav';
import MarketingNav from './MarketingNav';

// Nav for pages that are reachable both logged in and logged out (About,
// Pricing, Help, Privacy, Terms, Automation Disclosure). Logged-in users get
// the full app nav so they can navigate back into the app; logged-out visitors
// get the marketing nav (matching the landing page) instead of app tabs that
// would only bounce them to the login screen.
export default function PublicNav() {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <AppNav /> : <MarketingNav />;
}
